import { useQuery } from '@tanstack/react-query'

import { queryKeys } from '@/shared/hooks/queries/queryKeys'

import { getSoapSets } from '../apis/masters'

/**
 * 定型文の一覧。
 *
 * 薬歴の挿入ダイアログと設定ページの両方がここから読む。**独自の staleTime を置かず
 * アプリ既定 (30 秒) に従う** —— 定型文は店舗の共有資産で、隣の薬剤師が直した結果が
 * 見えないと「直したのに反映されない」になる (自分の編集は mutation の invalidate が
 * 拾うが、他人の編集は拾えない)。取込済みの静的資産として 30 分寝かせていた頃の前提は
 * 編集可能になった時点で崩れている。
 *
 * `hasAny` が false なら挿入導線ごと出さない (空のダイアログを見せない)。
 * ただし**設定ページはこの判定を使わない** —— 0 件の店が永久に登録できなくなるため。
 *
 * `enabled` は「そもそもこの面に定型文の口があるか」の門で、既定は開いている。
 * 薬歴側は埋め込みのときだけ口を出すので false を渡しうるが、設定ページは常に読む。
 */
export const useSoapMasters = (enabled = true) => {
  const query = useQuery({
    queryKey: queryKeys.soapMasters.list(),
    queryFn: getSoapSets,
    enabled,
  })

  const soapSets = query.data ?? []

  return {
    soapSets,
    isLoading: query.isLoading,
    error: query.error,
    hasAny: soapSets.length > 0,
  }
}
